exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "not-allowed .list-empty{margin-top:40px;text-align:center;font-family:Stag Sans;font-weight:400;font-size:19px;color:#0072c9}not-allowed .list-empty.shown-filter{margin-top:0}not-allowed .list-empty .icon-warning{font-size:77px;margin-right:11px;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/features/notAllowed/notAllowed.scss
// module id = 1062
// module chunks = 0